import { useEffect } from "react";
import { useProfilePreference } from "src/common/utils/hooks/useProfilePreference.js";

export let setSidebarOpenStatus: undefined | ((value: boolean) => void);

export const useCollapsibleSidebar = () => {
	const [collapsedSidebar, setCollapsedSidebar] = useProfilePreference(
		"collapsedSidebar",
		false,
	);

	useEffect(() => {
		setSidebarOpenStatus = (open) => {
			setCollapsedSidebar(!open);
		};
		return () => {
			setSidebarOpenStatus = undefined;
		};
	}, [setCollapsedSidebar]);

	const toggleSidebar = () => {
		setCollapsedSidebar(!collapsedSidebar);
	};

	return { toggleSidebar, open: !collapsedSidebar };
};
